export class LabDetail {
    labHeaderId: number;
    labDetailId: number;
    testParameter: string;
    referenceRange: string;
    refrenceRangeUnit: number
    active: boolean;
    name: string;
}